<template>
  <div class="mx-auto package-preview w-100 h-100">
    <package-mobile-box
      :content="previewContent"
      :cover="coverUrl"
      :thumbnail="thumbnailUrl"
      class="mobile-box"
    ></package-mobile-box>
  </div>
</template>

<script>
import { getCookie, Auth } from "@/lib/cookie"
import PackageMobileBox from "@/components/admin/view/package/PackageMobileBox"
import { baanRueJaiClient } from "@/dependencies"

export default {
  name: "PackagePreview",
  components: {
    PackageMobileBox,
  },
  data() {
    return {
      // Package basic info
      name: "",
      receiptName: "",
      detail: "",
      termsAndConditions: "",

      // Pricing
      price: 0,
      originalPrice: null,
      billingCycle: 1,

      // Package settings
      target: "",
      isSecret: false,

      // Images
      coverUrl: "",
      thumbnailUrl: "",

      // Related data
      projects: [],
      services: [],
      homes: [],

      // Route params
      packageId: this.$route.params.packageId,
    }
  },
  computed: {
    previewContent() {
      return {
        name: this.name,
        receiptName: this.receiptName,
        detail: this.detail,
        price: this.price,
        originalPrice: this.originalPrice,
        target: this.target,
        billingCycle: this.billingCycle,
        termsAndConditions: this.termsAndConditions,
        projects: this.projects,
        services: this.services,
        homes: this.homes,
        isSecret: this.isSecret,
      }
    },
  },

  async created() {
    await this.checkAuthentication()
    await this.fetchPackageData()
  },
  methods: {
    /**
     * Check if user is authenticated, redirect to login if not
     */
    checkAuthentication() {
      const token = getCookie(Auth.AccessToken)

      if (!token) {
        this.$router.push({
          path: "/admins/logins",
          query: { redirect: `/admins/packages/preview/${this.packageId}` },
        })
      }
    },

    /**
     * Fetch package data from API and populate component data
     */
    async fetchPackageData() {
      try {
        const response =
          await baanRueJaiClient.admin.subscriptions.recommend_packages.get(
            this.packageId,
          )
        const packageData = response.data.result

        this.populatePackageData(packageData)
        await this.handleImages(packageData)
      } catch (error) {
        this.handleApiError(error)
      }
    },

    /**
     * Populate component data from API response
     */
    populatePackageData(data) {
      const {
        name,
        receipt_name: receiptName,
        detail,
        target,
        price,
        billing_cycle: billingCycle,
        terms_and_conditions: termsAndConditions,
        original_price: originalPrice,
        projects,
        services,
        homes,
        is_secret: isSecret,
      } = data

      // Basic package info
      this.name = name
      this.receiptName = receiptName
      this.detail = detail
      this.target = target
      this.termsAndConditions = termsAndConditions
      this.billingCycle = billingCycle
      this.isSecret = Boolean(isSecret)

      // Convert prices from satang to baht
      this.price = price / 100
      this.originalPrice = originalPrice ? originalPrice / 100 : null

      // Related data arrays
      this.projects = projects || []
      this.services = services || []
      this.homes = homes || []
    },

    /**
     * Handle image URLs - download if needed
     */
    async handleImages(data) {
      const { image_url: imageUrl, thumbnail_url: thumbnailUrl } = data

      if (imageUrl) {
        this.coverUrl = this.isDirectUrl(imageUrl)
          ? imageUrl
          : await this.downloadImage(imageUrl)
      }

      if (thumbnailUrl) {
        this.thumbnailUrl = this.isDirectUrl(thumbnailUrl)
          ? thumbnailUrl
          : await this.downloadThumbnail(thumbnailUrl)
      }
    },

    /**
     * Check if URL is direct HTTP URL or needs downloading
     */
    isDirectUrl(url) {
      return url && url.startsWith("http")
    },

    /**
     * Download image and return URL
     */
    async downloadImage(imageKey) {
      try {
        const response = await baanRueJaiClient.downloadImage(imageKey)
        return response.data.url
      } catch (error) {
        // eslint-disable-next-line no-console
        console.error("Error downloading image:", error)
        return null
      }
    },

    /**
     * Download thumbnail and return URL
     */
    async downloadThumbnail(thumbnailKey) {
      try {
        const response = await baanRueJaiClient.downloadImage(thumbnailKey)
        return response.data.url
      } catch (error) {
        // eslint-disable-next-line no-console
        console.error("Error downloading thumbnail:", error)
        return null
      }
    },

    /**
     * Handle API errors with user-friendly messages
     */
    handleApiError(error) {
      const errorMessage = error.response
        ? error.response.data.message || "ไม่สามารถดึงข้อมูลได้"
        : "เกิดข้อผิดพลาดในการเชื่อมต่อกับเซิร์ฟเวอร์"

      this.$message.error(errorMessage)
    },
  },
}
</script>

<style scoped>
.package-preview {
  overflow-y: scroll;
  display: flex;
  justify-content: center;
}

.package-preview .mobile-box {
  background-color: white;
  box-shadow: 0 0px 3px 0 rgba(0, 0, 0, 0.2);
  border-radius: 12px;
  max-width: 50vw;
  height: max-content;
  margin: 24px 0;
}

@media screen and (max-width: 768px) {
  .package-preview .mobile-box {
    max-width: 100vw;
    box-shadow: 0;
    border-radius: 0;
    margin: 0;
  }
  .package-preview .cover {
    border-radius: 0 !important;
  }
}

@media screen and (min-width: 1280px) {
  .package-preview .mobile-box {
    max-width: 640px;
  }
}
</style>
